import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
  Font,
  Link,
} from "@react-pdf/renderer";

import logoCria from "../../../assets/image/logocria.png";

import dayjs from "dayjs";
import "dayjs/locale/pt-br";
dayjs.locale("pt-br");

Font.register({
  family: "Work Sans",
  src: "https://fonts.gstatic.com/s/worksans/v2/z9rX03Xuz9ZNHTMg1_ghGS3USBnSvpkopQaUR-2r7iU.ttf",
});

Font.register({
  family: "Inter",
  fonts: [
    {
      src: "https://fonts.gstatic.com/s/inter/v11/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuLyfAZFhjQ.ttf",
    },
    {
      src: "https://fonts.gstatic.com/s/inter/v11/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuFuYAZFhjQ.ttf",
      fontWeight: "bold",
    },
  ],
});

const stylesTable = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "#FFFFFF",
  },
  body: {
    paddingTop: 125,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  imgCria: {
    width: 125,
    height: 68,
    marginBottom: 6,
  },
  containerHeader: {
    // backgroundColor: "rgb(248, 163, 0)",
    // display: "flex",
    // justifyContent: "space-between",
    borderBottom: "1px solid rgb(248, 163, 0)",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    marginBottom: 55,
  },
  wrapperHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignContent: "stretch",
    flexWrap: "nowrap",
    alignItems: "stretch",
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: 35,
    padding: 16,
    paddingBottom: 12,
  },
  titleHeader: {
    fontSize: 20,
    fontFamily: "Work Sans",
    color: "#1259a5",
    marginBottom: 20,
    textAlign: "center",
    paddingTop: 10,
    // fontWeight: 'bold',
    // display: "inline",
  },
  title: {
    fontSize: 14,
    marginBottom: 6,
    textAlign: "center",
    lineHeight: 1.5,
    fontFamily: "Work Sans",
    color: "#667085",
  },
  text: {
    fontSize: 12,
    fontFamily: "Inter",
    color: "#667085",
    marginBottom: 16,
    // display: "inline",
  },
  em: {
    fontWeight: "bold",
    color: "black",
    backgroundColor: "#3f8cd9",
  },
  table: {
    width: "100%",
    borderWidth: 2,
    display: "flex",
    flexDirection: "column",
    marginVertical: 12,
  },
  tableRow: {
    display: "flex",
    flexDirection: "row",
  },
  cell: {
    borderWidth: 1,
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    textAlign: "center",
    flexWrap: "wrap",
  },
  cityText: {
    marginBottom: 16,
    fontWeight: "bold",
    fontSize: 18,
    fontFamily: "Inter",
  },
  additionalInfoTitle: {
    color: "blue",
    marginBottom: 10,
  },
  additionalInfoText: {
    color: "orange",
    marginBottom: 15,
    marginLeft: 10,
  },
  footer: {
    position: "absolute",
    fontSize: 12,
    bottom: 20,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
    fontFamily: "Inter",
  },
});

export const RelatorioCartaoCria = ({ colTableOne, th, tableCities }) => (
  <Document>
    <Page style={stylesTable.body}>
      <View style={stylesTable.containerHeader} fixed>
        <View style={stylesTable.wrapperHeader}>
          <Image src={logoCria} style={stylesTable.imgCria} />
        </View>
      </View>

      <Text style={stylesTable.titleHeader}>Relatório do Cartão CRIA</Text>

      {tableCities.map((item, i) => {
        return (
          <View key={item.city + i}>
            <Text style={stylesTable.cityText}>Cidade de {item.city}</Text>
            <Text>Família em extrema pobreza (até R$ 109) </Text>
            <View style={stylesTable.table} wrap={false}>
              {item.extremaPobreza.map((row, ind) => (
                <View
                  key={ind}
                  style={[
                    stylesTable.tableRow,
                    th && ind === 0 ? stylesTable.em : {},
                  ]}
                >
                  {row.map((cell, j) => (
                    <View
                      key={j}
                      style={[
                        stylesTable.cell,
                        { width: colTableOne[j], height: 40 },
                      ]}
                    >
                      {typeof cell === "string" || typeof cell === "number" ? (
                        <Text>{cell}</Text>
                      ) : (
                        cell
                      )}
                    </View>
                  ))}
                </View>
              ))}
            </View>
            <Text>Família em pobreza (de R$ 109 até R$ 218) </Text>
            <View style={stylesTable.table} wrap={false}>
              {item.pobreza.map((row, ind) => (
                <View
                  key={ind}
                  style={[
                    stylesTable.tableRow,
                    th && ind === 0 ? stylesTable.em : {},
                  ]}
                >
                  {row.map((cell, j) => (
                    <View
                      key={j}
                      style={[
                        stylesTable.cell,
                        { width: colTableOne[j], height: 40 },
                      ]}
                    >
                      {typeof cell === "string" || typeof cell === "number" ? (
                        <Text>{cell}</Text>
                      ) : (
                        cell
                      )}
                    </View>
                  ))}
                </View>
              ))}
            </View>

            <Text
              style={{
                color: "orange",
                marginBottom: 15,
              }}
            >
              Total de Crianças de 0 a 6 anos em situação de Pobreza e Extrema
              Pobreza:{" "}
              <Text style={{ color: "black" }}>
                {item.additionalInfo.totalCriancas0a6}
              </Text>
            </Text>

            <Text style={stylesTable.additionalInfoTitle}>
              Situação Cadastral do Município
            </Text>
            <Text style={stylesTable.additionalInfoText}>
              Beneficiários Ativos:{" "}
              <Text style={{ color: "black" }}>
                {item.additionalInfo.beneficiariosAtivos}
              </Text>
            </Text>
            <Text style={stylesTable.additionalInfoText}>
              Beneficiários Inativos:{" "}
              <Text style={{ color: "black" }}>
                {item.additionalInfo.beneficiariosInativos}
              </Text>
            </Text>
            <Text style={stylesTable.additionalInfoText}>
              Gestantes:{" "}
              <Text style={{ color: "black" }}>
                {item.additionalInfo.gestantes}
              </Text>
            </Text>
            <Text style={stylesTable.additionalInfoText}>
              Crianças com Zica a Síndrome do Vírus:{" "}
              <Text style={{ color: "black" }}>
                {item.additionalInfo.criancasComZica}
              </Text>
            </Text>
            <Text style={stylesTable.additionalInfoText}>
              Crianças até 6 anos de idade:{" "}
              <Text style={{ color: "black" }}>
                {item.additionalInfo.criancasAte6Anos}
              </Text>
            </Text>
            <Text
              style={{ ...stylesTable.additionalInfoText, marginBottom: 20 }}
            >
              Gêmeos:{" "}
              <Text style={{ color: "black" }}>
                {item.additionalInfo.gemeos}
              </Text>
            </Text>
          </View>
        );
      })}

      <Text style={stylesTable.footer} fixed>
        {`Realização: `}
        <Link
          style={{
            paddingLeft: 60,
            color: "grey",
          }}
          src={"https://orion.ufal.br/"}
        >
          Orion
        </Link>
      </Text>
    </Page>
  </Document>
);
